/**
 * deepClone
 * - no support for symbols, undefined, BigInt
 * - uses structuredClone if available in browser
 * - uses JSON clone as fallback
 * @param {object|null} source - object to clone
 * @param {?boolean} forceJsonClone - flag to force using JSON clone
 * @returns {object|null}
 */
export const deepClone = (source = null, { forceJsonClone = false } = {}) => {
  if (source === null) return null;
  if (typeof structuredClone !== 'function') {
    forceJsonClone = true;
    console.debug(
      '[deepClone]: structuredClone unavailable, using JSON clone as fallback.',
    );
  }
  return forceJsonClone
    ? JSON.parse(JSON.stringify(source))
    : structuredClone(source);
};
